import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/grupos')({
  component: lazyRouteComponent(
    () => import('@/features/grupos-table/components/grupos-table-page'),
    'GruposTablePage'
  ),
})
